export default "__VITE_ASSET__a0b5950c__"